import React from 'react';

function TvSad() {
  /* eslint-disable max-len */
  return (
    <svg width="44" height="36" viewBox="0 0 44 36" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="evenodd">
        <path d="M40 0H4C1.78 0 0 1.78 0 4v24c0 2.2 1.78 4 4 4h10v4h16v-4h10c2.2 0 3.98-1.8 3.98-4L44 4c0-2.22-1.8-4-4-4zm0 28H4V4h36v24z"/>
        <path d="M27 13.5c0 1-.5 1.5-1.5 1.5s-1.5-.5-1.5-1.5.5-1.5 1.5-1.5 1.5.5 1.5 1.5zm-7 0c0 1-.5 1.5-1.5 1.5s-1.5-.5-1.5-1.5.5-1.5 1.5-1.5 1.5.5 1.5 1.5zm2 4.5c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2 1.48 0 2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"/>
      </g>
    </svg>
  );
  /* eslint-enable */
}

export default TvSad;



// WEBPACK FOOTER //
// ./src/common/icons/TvSad.js